import { render, staticRenderFns } from "./FormControlTypeNumber.vue?vue&type=template&id=6687fe3e&scoped=true"
import script from "./FormControlTypeNumber.vue?vue&type=script&lang=js"
export * from "./FormControlTypeNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687fe3e",
  null
  
)

export default component.exports